import { Helmet } from 'react-helmet';
import { useConfigContext } from '../../contexts/ConfigContext';
import { usePlayerContext } from '../../contexts/PlayerContext';

function Head(): JSX.Element {
  const { ui, id } = useConfigContext();
  const { currentTrack } = usePlayerContext();

  if (!ui) return <></>;
  /** @TOASK to use the page here like this is inconsistent, instead we can parse the seo stuff, because it isn't necessary in the widget? */
  const { page } = ui;
  const { description, title } = page.seo;

  return (
    <Helmet>
      <script defer data-domain={`play.heardis.com,play.heardis.com/${id}`} src="https://stats.heardis.com/js/script.js" />
      <script dangerouslySetInnerHTML={{ __html: 'window.plausible = window.plausible || function() {(window.plausible.q = window.plausible.q || []).push(arguments)}' }} />
      <title>{`${title}${currentTrack ? ` - ${currentTrack.track.title} by ${currentTrack.track.artist}` : ''}`}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}

export default Head;
